/**
 * Exploration cycle vocabulary shared by the API, the web client and the
 * CLI, so "is this cycle still running" is answered in one place.
 *
 * @module exploration
 */

export type ExplorationCycleStatus =
  | 'dispatching'
  | 'exploring'
  | 'reconciling'
  | 'completed'
  | 'failed';

/** Statuses that hold the one-active-cycle-per-property slot. */
export const ACTIVE_EXPLORATION_CYCLE_STATUSES: readonly ExplorationCycleStatus[] = [
  'dispatching',
  'exploring',
  'reconciling',
];

export function isActiveExplorationCycleStatus(status: string): boolean {
  return (ACTIVE_EXPLORATION_CYCLE_STATUSES as readonly string[]).includes(status);
}
